export const galleryItems = [
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/14/16/43/rchids-4202820__480.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/14/16/43/rchids-4202820_1280.jpg',
    description: 'Hokkaido Flower',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/14/22/05/container-4203677__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/14/22/05/container-4203677_1280.jpg',
    description: 'Container Haulage Freight',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/16/09/47/beach-4206785__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/16/09/47/beach-4206785_1280.jpg',
    description: 'Aerial Beach View',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2016/11/18/16/19/flowers-1835619__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2016/11/18/16/19/flowers-1835619_1280.jpg',
    description: 'Flower Blooms',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2018/09/13/10/36/mountains-3674334__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2018/09/13/10/36/mountains-3674334_1280.jpg',
    description: 'Alpine Mountains',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/16/23/04/landscape-4208571__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/16/23/04/landscape-4208571_1280.jpg',
    description: 'Mountain Lake Sailing',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/17/09/27/the-alps-4209272__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/17/09/27/the-alps-4209272_1280.jpg',
    description: 'Alpine Spring Meadows',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/16/21/10/landscape-4208255__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/16/21/10/landscape-4208255_1280.jpg',
    description: 'Nature Landscape',
  },
  {
    preview:
      'https://cdn.pixabay.com/photo/2019/05/17/04/35/lighthouse-4208843__340.jpg',
    original:
      'https://cdn.pixabay.com/photo/2019/05/17/04/35/lighthouse-4208843_1280.jpg',
    description: 'Lighthouse Coast Sea',
  },
  {
    preview: './img/1.jpg',
    original: './img/1x2.jpg',
    description: 'Team brainstorming with sticky notes and sketches',
  },
  {
    preview: './img/2.jpg',
    original: './img/2x2.jpg',
    description: 'Hand holding a glowing light bulb idea',
  },
  {
    preview: './img/3.jpg',
    original: './img/3x2.jpg',
    description: 'Smartphone with UI design and coffee on table',
  },
  {
    preview: './img/4.jpg',
    original: './img/4x2.jpg',
    description: 'Modern meeting room with large windows',
  },
  {
    preview: './img/5.jpg',
    original: './img/5x2.jpg',
    description: 'Creative office interior with colorful wall',
  },
  {
    preview: './img/6.jpg',
    original: './img/6x2.jpg',
    description: 'Developers working in open space office',
  },
  {
    preview: './img/7.jpg',
    original: './img/7x2.jpg',
    description: 'Workspace with laptop, coffee and notebook',
  },
  {
    preview: './img/8.jpg',
    original: './img/8x2.jpg',
    description: 'Person typing on laptop in cozy sweater',
  },
  {
    preview: './img/9.jpg',
    original: './img/9x2.jpg',
    description: 'Business presentation in meeting room',
  },
];
